// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as operations from '../../redux/ducks/advertisementTable/reducers'
import classNames from 'classnames'
import { Link, HeaderCell } from '../MainTable'

type Props = {|
  align?: string,
  field: string,
  className: string,
  name: string,
  notSortable?: boolean,
  calculatedField?: boolean,
  sortField?: string,
  sortDirection?: string,
  statisticsType?: string,
  dispatch: Function
|}

class HeadColumn extends Component<Props> {
  onClick() {
    const { sortDirection, sortField, field, notSortable, dispatch } = this.props

    if (notSortable) return

    if (sortField === field) {
      if (sortDirection === 'asc') {
        dispatch(operations.setSortDirection('desc'))
      } else if (sortDirection === 'desc') {
        dispatch(operations.setSortDirection('asc'))
      }
    } else {
      dispatch(operations.sortColumn(field, 'desc'))
    }
  }

  renderNotSortable() {
    return this.props.name
  }

  renderSortable() {
    const { name, field, sortField, sortDirection } = this.props

    const direction = field === sortField ? sortDirection : 'none'

    return (
      <span onClick={() => this.onClick()}>
        <Link className="t-SortLink">{name}</Link>
        <i
          className={classNames('sort-order-arrow', {
            'sort-order-arrow_desc': direction === 'desc',
            'sort-order-arrow_asc': direction === 'asc'
          })}
        />
      </span>
    )
  }

  render() {
    const { notSortable, statisticsType, calculatedField, className, align } = this.props
    let forbidSorting = false

    if (statisticsType === 'divided' && calculatedField) {
      forbidSorting = true
    }

    // the prop field renders to map its name
    // also it's used in test to find out filtering column
    return (
      <HeaderCell className={className} alignLeft={align === 'left'}>
        {notSortable || forbidSorting ? this.renderNotSortable() : this.renderSortable()}
      </HeaderCell>
    )
  }
}

function mapStateToProps(state) {
  const { sortField, sortDirection, statisticsType } = state.advertisementTable

  return { sortField, sortDirection, statisticsType }
}

export default connect<Object, Object, _, _, _, _>(mapStateToProps)(HeadColumn)
